import React from 'react'
import { useInstData } from 'tyan/public/hooks'

const _renderFns = {}

const LazyWrapper = ({ name, loadFn, args }) => {
	const { setState } = useInstData(null)

	const loadField = async () => {
		const m = await loadFn()
		m && m.default && (_renderFns[name] = m.default)
		if (!_renderFns[name]) {
			console.log('block field not found:', name)
			console.error()
		} else
			setState({})
	}

	const render = _renderFns[name]
	!render && loadField()
	return render ? render(...args) : <div>Loading...</div>
}

const _renderField = (name, loadFn) => (...args) => {
	const [{ key }] = args

	return <LazyWrapper key={key} {...{ name, loadFn, args }} />
}

export default _renderField